import { Component } from "react";
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../../utils/withRouter";
import "react-datepicker/dist/react-datepicker.css";
import Modal from "react-modal";
import Pagination from "../../../../utils/pagination";
import AdminDrawer from "../../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../../common_components/header_with_logo";
import { getExhibitionProgramListMaster_action, deleteProgramMaster_action, getExhibitionProgramDetailsMaster_action } from "../../../../actions/admin_module_action/delegate_master_action/delegate_program_action"
import { connect } from "react-redux";
import {
    DOC_BASE_URL,
    downloadReport,
    fetchAuthReport,
    NA,
    signatureDocName,
    toastError, bonafideDocName,
    toastSuccess, paymentMasterListActionId,
    BASE_URL
} from "../../../../utils/constants";
class Delegate_ProgramList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            isOpen: false, // For Delete Modal
            searchName: '',
            searchDate: '',
            programList: [],
            currentPage: 1,
            ExhProgramID: '',
        };
        this.updateItem = this.updateItem.bind(this);
    }

    handleAdd() {
        this.props.navigate('/delegateProgramListAU');
    }

    handleUpdate(data) {
        this.props.navigate('/delegateProgramListAU', { state: { programID: data, is_add: false } });
    }

    onDelete(id) {
        this.setState({ isOpen: true, ExhProgramID: id });
    }

    updateItem(item) {
        this.setState({ currentPage: item });
    }

    componentDidMount() {
        this.getExhibitionProgramListMaster()
    }

    getExhibitionProgramListMaster() {
        const { ExhibitionID, searchName, searchDate } = this.state
        this.setState({ isLoading: true })
        this.props.getExhibitionProgramListMaster_action(sessionStorage.getItem("sessionExhibitionID"), searchName != '' ? searchName : null, searchDate != '' ? searchDate : null)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({
                        programList: data.data[0],
                        isLoading: false,
                        currentPage: 1
                    })
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    onDeleteProgram() {
        const { ExhProgramID } = this.state
        this.setState({ isLoading: true })
        this.props.deleteProgramMaster_action(ExhProgramID)
            .then((data) => {
                if (data.error != 1) {
                    toastSuccess("delete successful")
                    this.getExhibitionProgramListMaster()
                    this.setState({ isLoading: false, isOpen: false  })
                } else {
                    this.setState({ isLoading: false, isOpen: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }


    record(list) {
        return (
            <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                <thead>
                    <tr>
                        <th style={{ width: '50px' }}>Sr. No.</th>
                        <th>Program</th>
                        <th>Date</th>
                        <th>Day of week</th>
                        <th>Start Time</th>
                        <th>End Time</th>
                        <th>Location</th>
                        <th style={{ width: '40px' }} className="text-center">Action</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        list.length > 0 ? (
                            list.map((data, i) => (
                                <tr key={i}>
                                    <td className="text-center">{data.SrNo}</td>
                                    <td style={{ whiteSpace: 'pre-line' }}>{data.ProgramName}</td>
                                    <td>{data.Date}</td>
                                    <td>{data.DayOfWeek}</td>
                                    <td>{data.StartTime}</td>
                                    <td>{data.EndTime}</td>
                                    <td>{data.Location}</td>
                                    <td className="text-center" style={{ width: '40px' }}>
                                        <button
                                            type="button"
                                            className="btn btn-aqua mx-1 py-1"
                                            onClick={(e) => this.handleUpdate(data.ExhProgramID)}
                                        >
                                            Edit
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-outline-danger btn-sm  mx-1 py-1"
                                            onClick={(e) => this.onDelete(data.ExhProgramID)}
                                        >
                                            Delete
                                        </button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr><td colSpan={8} style={{ textAlign: 'center' }}>Record not found</td></tr>
                        )
                    }
                </tbody>
            </table>
        );
    }

    render() {
        const { isLoading, currentPage, programList, isOpen, searchName, searchDate } = this.state;
        const recordsPerPage = 10;
        const nPages = Math.ceil(programList.length / recordsPerPage);

        return (
            <>
                <ToastContainer />
                <HeaderWithLogo />

                <div className="app-content with-dr-container com-height" style={{ marginTop: '5rem' }}>
                    <AdminDrawer />
                    <div className="row" style={{ marginLeft: '0.3rem' }}>
                        <div className="step-name">
                            <p>Program List</p>
                        </div>
                    </div>
                    <div className="m-3">
                        <div className="row mb-1">
                            <div className="col-md-3 mb-2">
                                <label>Program Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={searchName}
                                    onChange={(e) => this.setState({ searchName: e.target.value })}
                                    placeholder="Search by name"
                                />
                            </div>
                            <div className="col-md-3 mb-2">
                                <label>Date</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    value={searchDate}
                                    onChange={(e) => this.setState({ searchDate: e.target.value })}
                                />
                            </div>
                            <div className="col-md-6 mb-2 d-flex align-items-end justify-content-end">
                                <button type="button" className="btn btn-aqua px-3 mx-1" onClick={() => this.getExhibitionProgramListMaster()}>
                                    Search
                                </button>
                                <button type="button" className="btn btn-gray rounded-1 px-3 mx-1" onClick={() => this.setState({ searchName: '', searchDate: '' }, () => {
                                    this.getExhibitionProgramListMaster()
                                })}>
                                    Clear
                                </button>
                            </div>
                        </div>

                        <div className="col-md-12 pt-0 pb-0 px-0">
                            <div className="d-flex justify-content-end mb-2">
                                <button type="button" className="btn btn-aqua mx-1"
                                    onClick={e => this.handleAdd()}
                                >
                                    Add Program
                                </button>
                            </div>
                            <div className="table-responsive">
                                {this.record(programList)}
                            </div>
                            <div className="row">
                                <div className="col-md-9 pl-0">
                                    <div className="mt-2 float">
                                        {
                                            programList.length > 0 ? (
                                                <Pagination
                                                    nPages={nPages}
                                                    currentPage={currentPage}
                                                    setCurrentPage={this.updateItem}
                                                />
                                            ) : <></>
                                        }
                                    </div>
                                </div>
                                <div className="col-md-3 text-right">
                                    <div className="tab-rec mt-3" style={{ float: "right" }}>
                                        <p>{`${currentPage} of ${nPages || 1} pages`}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>



                <Modal isOpen={isOpen} onRequestClose={() => this.setState({ isOpen: false })}>
                    <div className="modal-dialog" style={{ marginTop: '10%' }}>
                        <div className="modal-content confirm-logout">
                            <div className="modal-header text-right p-2">
                                <h5 className="modal-title">Do you really want to delete this record?</h5>
                            </div>
                            <div className="modal-footer p-1">
                                <div className="form-group text-right mod-fot">
                                    <button type="button" className="btn btn-del-pop"
                                        onClick={() => this.onDeleteProgram()}
                                    >Yes</button>
                                    <button type="button" className="btn btn-gray" data-dismiss="modal" style={{ marginLeft: '5px' }}
                                        onClick={() => this.setState({ isOpen: false })}
                                    >No</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
            </>
        );
    }
}
export default withRouter(
    connect(null, {
        getExhibitionProgramListMaster_action, getExhibitionProgramDetailsMaster_action, deleteProgramMaster_action
    })(Delegate_ProgramList)
);
